import { render, staticRenderFns } from "./SingleSignature.vue?vue&type=template&id=21acead2&"
import script from "./SingleSignature.vue?vue&type=script&lang=js&"
export * from "./SingleSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports